// TikTok Influencer Data - Cluster SIE Reviews
export const tiktokInfluencers = [
  {
    id: 1,
    channel: 'Ham PMN',
    avatar: '🎬',
    clips: [
      { id: 101, url: 'https://vt.tiktok.com/ZSaR8mKCc/', title: 'คลิปที่ 1', videoId: null },
      { id: 102, url: 'https://vt.tiktok.com/ZSaL4cC1a/', title: 'คลิปที่ 2', videoId: null },
      { id: 103, url: 'https://vt.tiktok.com/ZSaN1v8Qa/', title: 'คลิปที่ 3', videoId: null },
      { id: 104, url: 'https://vt.tiktok.com/ZSaYgHkUq/', title: 'คลิปที่ 4', videoId: null },
      { id: 105, url: 'https://vt.tiktok.com/ZSaYgwMpw/', title: 'คลิปที่ 5', videoId: null },
    ],
  },
  {
    id: 2,
    channel: 'ซอล สงขลา',
    avatar: '🎥',
    clips: [
      { id: 201, url: 'https://vt.tiktok.com/ZSajNWqgT/', title: 'คลิปที่ 1', videoId: null },
      { id: 202, url: 'https://vt.tiktok.com/ZSajNwmbW/', title: 'คลิปที่ 2', videoId: null },
      { id: 203, url: 'https://vt.tiktok.com/ZSajF8ehc/', title: 'คลิปที่ 3', videoId: null },
      { id: 204, url: 'https://vt.tiktok.com/ZSajNEyfv/', title: 'คลิปที่ 4', videoId: null },
      { id: 205, url: 'https://vt.tiktok.com/ZSajF6bPb/', title: 'คลิปที่ 5', videoId: null },
    ],
  },
  {
    id: 3,
    channel: 'จุจูจุ๊กกรู่',
    avatar: '🎭',
    clips: [
      { id: 301, url: 'https://vt.tiktok.com/ZSaFGkd3g/', title: 'คลิปที่ 1', videoId: null },
      { id: 302, url: 'https://vt.tiktok.com/ZSaFGh4AG/', title: 'คลิปที่ 2', videoId: null },
      { id: 303, url: 'https://vt.tiktok.com/ZSaFGykUb/', title: 'คลิปที่ 3', videoId: null },
      { id: 304, url: 'https://vt.tiktok.com/ZSaFGPCXu/', title: 'คลิปที่ 4', videoId: null },
      { id: 305, url: 'https://vt.tiktok.com/ZSaFteSP4/', title: 'คลิปที่ 5', videoId: null },
    ],
  },
  {
    id: 4,
    channel: 'ไอ้หมูตอน',
    avatar: '🐷',
    clips: [
      { id: 401, url: 'https://vt.tiktok.com/ZSajNoUxa/', title: 'คลิปที่ 1', videoId: null },
      { id: 402, url: 'https://vt.tiktok.com/ZSajF6hTV/', title: 'คลิปที่ 2', videoId: null },
      { id: 403, url: 'https://vt.tiktok.com/ZSajNnXU8/', title: 'คลิปที่ 3', videoId: null },
      { id: 404, url: 'https://vt.tiktok.com/ZSajNcfeh/', title: 'คลิปที่ 4', videoId: null },
      { id: 405, url: 'https://vt.tiktok.com/ZSajFeaCF/', title: 'คลิปที่ 5', videoId: null },
    ],
  },
]
